module.exports = __webpack_public_path__ + "static/media/snoopyfewclouds03.7b575c10.gif";